<template>
  <div
    ref="wfSelect"
    class="tail-select w-full hide-selected hide-disabled multiple"
    :class="{ active: show }"
  >
    <div class="select-label tail-select-container" @click.stop="showList">
      <span class="label-inner" v-if="!itemSelected.length"
        >Select up to {{ options.multipleLimit }} Options...</span
      >
      <div
        v-else
        class="select-handle"
        data-group="#"
        v-for="(itemS, inx) in itemSelected"
        :key="itemS.employee_id"
        @click.stop="removeSelected(inx)"
      >
        {{ itemS.fullname_th }}
      </div>
    </div>

    <div
      class="select-dropdown relative"
      style="max-height 348px; height: auto; display: block; overflow: visible;"
      v-show="show"
    >
      <div class="dropdown-search">
        <input
          type="text"
          autofocus
          ref="searchInputRef"
          v-model="searchInput"
          @keydown.esc="searchClear"
          class="search-input"
          placeholder="Type in serach... 3 charactor"
        />
      </div>
      <div class="dropdown-inner">
        <ul class="dropdown-optgroup relative" style="max-height: 300px;">
          <li
            class="dropdown-option"
            v-for="item in items"
            :key="item.employee_id"
            @click="handleSelected(item)"
            v-show="hideSelected(item.employee_id)"
          >
            {{ item.fullname_th }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  watch,
  reactive,
  computed,
  onMounted,
  onUpdated
} from 'vue'
// import { onClickOutside } from '@vueuse/core'

export default defineComponent({
  name: 'wf-select',
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    modelValue: {
      type: Array,
      default() {
        return []
      }
    }
  },
  emits: ['update:modelValue'],
  setup(props, context) {
    const show = ref(false)
    const searchInput = ref(null)
    const searchInputRef = ref(null)
    const showList = async () => {
      show.value = !show.value
      searchInput.value = ''
    }

    // watch(
    //   () => [...props.modelValue],
    //   (newVal, oldVal) => {
    //     console.log('enw: ', newVal, oldVal)
    //     init()
    //   }
    // )

    const items = computed(() => {
      if (searchInput.value) {
        if (searchInput.value.length >= props.options.searchMinLength) {
          return props.options.items.filter(item => {
            return item.fullname_th.includes(searchInput.value)
          })
        } else {
          return []
        }
      } else {
        return props.options.items.filter((item, inx) => {
          return item.wf_level >= 10
        })
      }
    })

    const itemSelected = reactive([])
    const init = async () => {
      // console.log('init: ', props.options.items)
      await props.modelValue.map(employeeId => {
        const item = props.options.items.find(i =>
          i.employee_id.includes(employeeId)
        )
        if (item) {
          itemSelected.push(item)
        }
      })
    }
    const handleSelected = item => {
      const chk = itemSelected.filter(i =>
        i.employee_id.includes(item.employee_id)
      )
      if (
        chk.length === 0 &&
        itemSelected.length < props.options.multipleLimit
      ) {
        itemSelected.push(item)
        context.emit(
          'update:modelValue',
          itemSelected.map(item => item.employee_id)
        )
        searchInput.value = ''
        showList()
      }
    }
    const removeSelected = inx => {
      itemSelected.splice(inx, 1)
      context.emit(
        'update:modelValue',
        itemSelected.map(item => item.employee_id)
      )
    }
    const hideSelected = id => {
      const test = itemSelected.filter(item => item.employee_id === id)
      return test.length !== 1
    }
    const searchClear = () => {
      searchInput.value = ''
    }

    let checkInit = true

    watch(
      () => [...props.modelValue],
      (newVal, oldVal) => {
        // console.log('watch: ', newVal, newVal.length)
        // console.log('watch: ', checkInit && itemSelected.length === 0)
        if (checkInit && itemSelected.length === 0) {
          checkInit = false
          init()
        } else if (newVal.length === 0) {
          itemSelected.splice(0)
        }
      }
    )
    // console.log('props:', props.modelValue.length)
    onMounted(() => {
      // console.log(
      //   'mounted: ',
      //   props.modelValue.length,
      //   itemSelected.length,
      //   checkInit
      // )
      if (props.modelValue.length) {
        if (checkInit && itemSelected.length === 0) {
          checkInit = false
          setTimeout(() => {
            init()
          }, 500)
        }
      }
    })

    onUpdated(() => {
      searchInputRef.value.focus()
    })

    return {
      show,
      showList,
      searchInput,
      searchInputRef,
      items,
      itemSelected,
      handleSelected,
      removeSelected,
      hideSelected,
      searchClear
      //   wfSelect
    }
  }
})
</script>
